// Offline testMode
export const INIT_OFFLINE_MODE = "init_offline_mode";

// Old alerts
export const SET_SNACK_BAR = "set_snack_bar";
export const SHOW_ALERT = "show_alert";
export const HIDE_ALERT = "hide_alert";

export const SHOW_EDIT_EMAIL_MODAL = "show_edit_email_modal";
export const HIDE_EDIT_EMAIL_MODAL = "hide_edit_email_modal";
export const SHOW_EDIT_PASSWORD_MODAL = "show_edit_password_modal";
export const HIDE_EDIT_PASSWORD_MODAL = "hide_edit_password_modal";

export const TOGGLE_MENU = "toggle_menu";

export const SET_COMMUNITY = "set_community";
export const SET_USER = "set_user";
export const SET_TOKEN = "set_token";
export const RESET_USER = "reset_user";

export const SET_BOOKINGS = "set_bookings";
export const SET_TIMES = "set_times";
export const SET_LAUNDRIES = "set_laundries";
export const SET_LAUNDRIES_RULES = "set_laundry_rules";
export const ADD_BOOKING = "add_booking";
export const RESET_LAUNDRY_BOOKING = "reset_laundry_booking";

export const SET_LANGUAGE = "set_language";

export const SET_CONVERSATIONS = "set_conversations";
export const ADD_CONVERSATION = "add_conversation";
export const UPDATE_CONVERSATION = "update_conversation";

export const SET_PRIVILEGES = "set_privileges";

// Socket types
export const INITIALIZE_SOCKET = "initialize_socket";

// User types
export const SIGN_IN_USER = "sign_in_user";
export const SIGN_IN_USER_SUCCESS = "sign_in_user_success";
export const SIGN_IN_USER_FAILED = "sign_in_user_failed";
export const VALIDATE_USER = "validate_user";
export const VALIDATE_USER_SUCCESS = "validate_user_success";
export const VALIDATE_USER_FAILED = "validate_user_failed";
export const SIGN_OUT_USER = "sign_out_user";
export const VALIDATE_SIGN_UP_CODE = "validate_sign_up_code";
export const VALIDATE_SIGN_UP_CODE_SUCCESS = "validate_sign_up_code_success";
export const VALIDATE_SIGN_UP_CODE_ERROR = "validate_sign_up_code_error";
export const CREATE_USER = "create_user";
export const CREATE_USER_SUCCESS = "create_user_success";
export const CREATE_USER_ERROR = "create_user_error";
export const GET_SELF = "get_self";
export const GET_SELF_SUCCESS = "get_self_success";
export const GET_SELF_FAILED = "get_self_failed";
export const UPDATE_USER = "update_user";
export const UPDATE_USER_SUCCESS = "update_user_success";
export const UPDATE_USER_FAILED = "update_user_failed";
export const RESET_PASSWORD = "reset_password";
export const RESET_PASSWORD_SUCCESS = "reset_password_success";
export const RESET_PASSWORD_FAILED = "reset_password_failed";

export const ENABLE_PUSH_NOTIFICATIONS = "enable_push_notifications";

// Error report types
export const CONVERSATION_UPDATED = "conversation_updated";
export const UPDATE_MESSAGES = "messages_updated";
export const GET_MESSAGES = "get_messages";
export const GET_MESSAGES_SUCCESS = "get_messages_success";
export const GET_MESSAGES_FAILED = "get_messages_failed";
export const REMOVE_UPDATE_MESSAGES = "remove_messages_updated";
export const SEND_MESSAGE = "send_message";
export const FAILED_TO_SEND_MESSAGE = "failed_to_send_message";
export const SUCCESS_TO_SEND_MESSAGE = "success_to_send_message";
export const WRITE_MESSAGE = "write_message";
export const CONVERSATION_UPDATED_SUCCESSFUL =
  "conversation_updated_successful";
export const CONVERSATION_UPDATED_FAILED = "conversation_updated_failed";
export const CREATE_CONVERSATION = "create_conversation";
export const CREATE_CONVERSATION_SUCCESSFUL = "create_conversation_successful";
export const CREATE_CONVERSATION_FAILED = "create_conversation_failed";
export const NEW_ERROR_REPORT_CONVERSATION_RECIEVED =
  "new_error_report_conversation_recieved";
export const SET_ERROR_REPORT_RULES = "set_error_report_rules";
export const SEND_ERROR_REPORT_EMAIL = "send_error_report_email";
export const SEND_ERROR_REPORT_EMAIL_SUCCESSFUL =
  "send_error_report_email_successful";
export const SEND_ERROR_REPORT_EMAIL_FAILED = "send_error_report_email_failed";
export const SET_CURRENT_CONVERSATION = "set_current_conversation";
export const UNSET_CURRENT_CONVERSATION = "unset_current_conversation";

// Community information
export const SET_COMMUNITY_INFORMATION = "set_community_information";

// Laundry bookings action
export const MAKE_BOOKING = "make_booking";
export const MAKE_BOOKING_SUCCESS = "make_booking_success";
export const MAKE_BOOKING_FAILED = "make_booking_failed";

export const DELETE_BOOKING = "delete_booking";
export const DELETE_BOOKING_SUCCESS = "delete_booking_success";
export const DELETE_BOOKING_FAILED = "delete_booking_failed";

export const GET_LAUNDRY_SYSTEM = "get_laundry_system";
export const GET_LAUNDRY_SYSTEM_SUCCESS = "get_laundry_system_success";
export const GET_LAUNDRY_SYSTEM_FAILED = "get_laundry_system_failed";

//Feed Types
export const GET_POSTS = "get_posts";
export const GET_POSTS_SUCCESS = "get_posts_success";
export const GET_POSTS_FAILED = "get_posts_failed";

export const LIKE_POST = "like_post";
export const LIKE_POST_SUCCESSFUL = "like_post_successful";
export const LIKE_POST_FAILED = "like_post_failed";
export const DISLIKE_POST = "dislike_post";
export const DISLIKE_POST_SUCCESSFUL = "dislike_post_successful";
export const DISLIKE_POST_FAILED = "dislike_post_failed";
export const COMMENT_POST_SUCCESSFUL = "comment_post_successful";
export const COMMENT_POST_FAILED = "comment_post_failed";
export const SET_POST = "set_post";
export const SET_CURRENT_COMMENTS = "set_current_comments";
export const CREATE_NEW_POST_SUCCESSFUL = "create_new_post_successful";
export const CREATE_NEW_POST_FAILED = "create_new_post_failed";
export const CREATE_NEW_POST = "create_new_post";
export const REMOVE_TOAST_MESSAGE = "remove_toast_message";
export const DELETE_POST_SUCCESSFUL = "delete_post_successful";
export const DELETE_POST_FAILED = "delete_post_failed";
export const DELETE_COMMENT_SUCCESSFUL = "delete_comment_successful";
export const DELETE_COMMENT_FAILED = "delete_comment_failed";
export const DELETE_COMMENT = "delete_comment";
export const DELETE_POST = "delete_post";
export const COMMENT_POST = "comment_post";

// Booking system actions
export const GET_BOOKING_SYSTEM = "get_booking_system";
export const GET_BOOKING_SYSTEM_SUCCESS = "get_booking_system_success";
export const GET_BOOKING_SYSTEM_FAILED = "get_booking_system_failed";

export const CREATE_BOOKING_FOR_BOOKING_SYSTEM =
  "create_booking_for_booking_system";
export const CREATE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS =
  "create_booking_for_booking_system_success";
export const CREATE_BOOKING_FOR_BOOKING_SYSTEM_FAILED =
  "create_booking_for_booking_system_failed";

export const DELETE_BOOKING_FOR_BOOKING_SYSTEM =
  "delete_booking_for_booking_system";
export const DELETE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS =
  "delete_booking_for_booking_system_success";
export const DELETE_BOOKING_FOR_BOOKING_SYSTEM_FAILED =
  "delete_booking_for_booking_system_failed";

// Booking subscription actions
export const SUBSCIRBE_TO_BOOKING = "subscribe_to_booking";
export const SUBSCIRBE_TO_BOOKING_SUCCESS = "subscribe_to_booking_success";
export const SUBSCIRBE_TO_BOOKING_FAILED = "subscribe_to_booking_failed";

export const UNSUBSCIRBE_TO_BOOKING = "unsubscribe_to_booking";
export const UNSUBSCIRBE_TO_BOOKING_SUCCESS = "unsubscribe_to_booking_success";
export const UNSUBSCIRBE_TO_BOOKING_FAILED = "unsubscribe_to_booking_failed";

// Sign up association
export const VALIDATE_EMAIL_IS_UNIQUE = "validate_email_is_unique";
export const VALIDATE_EMAIL_IS_UNIQUE_SUCCESS =
  "validate_email_is_unique_success";
export const VALIDATE_EMAIL_IS_UNIQUE_FAILED =
  "validate_email_is_unique_failed";

export const CREATE_CORPORATION = "create_corporation";
export const CREATE_CORPORATION_SUCCESS = "create_corporation_success";
export const CREATE_CORPORATION_FAILED = "create_corporation_failed";

// Community information actions
export const GET_COMMUNITY_INFORMATIONS = "get_community_informations";
export const GET_COMMUNITY_INFORMATIONS_SUCCESS =
  "get_community_informations_success";
export const GET_COMMUNITY_INFORMATIONS_FAILED =
  "get_community_informations_failed";



// WEBPACK FOOTER //
// ./src/actions/Types.js